"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'trainer.tab.instructions': 'Instrucciones',
    'trainer.tab.upload': 'Subir Datos',
    'trainer.tab.config': 'Configurar Entrenamiento',
    'trainer.tab.training': 'Progreso del Entrenamiento',
    'trainer.tab.results': 'Resultados',
};
